import React from 'react';
import { RouteObject } from 'react-router-dom';
import { TeamDataFeedPage } from './containers/TeamDataFeedPage';
import { CreateDatafeed } from './containers/CreateDataFeed';
import { EditDataFeed } from './containers/EditDataFeed';
import { DataFeedRoutes } from './routesHelper';
import { DataFeedsPage } from './containers/DataFeedPage';

export const datafeedsRoutes: RouteObject[] = [
  {
    path: `${DataFeedRoutes.DataFeeds}`,
    element: (
      <React.Suspense fallback={null}>
        <DataFeedsPage />
      </React.Suspense>
    ),
  },
  {
    path: `${DataFeedRoutes.DataFeed}/:idTeam`,
    element: (
      <React.Suspense fallback={null}>
        <TeamDataFeedPage />
      </React.Suspense>
    ),
  },
  {
    path: `${DataFeedRoutes.DataFeed}/:idTeam/${DataFeedRoutes.CreateDataFeed}`,
    element: (
      <React.Suspense fallback={null}>
        <CreateDatafeed />
      </React.Suspense>
    ),
  },
  {
    path: `${DataFeedRoutes.DataFeed}/:idTeam/${DataFeedRoutes.EditDataFeed}/:idDataFeed`,
    element: (
      <React.Suspense fallback={null}>
        <EditDataFeed />
      </React.Suspense>
    ),
  },
];
